import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/system';
import { router } from '~/router';
import Icon from 'Components/Icon';
import { actions } from 'ducks/sites';
import React from 'react';
import { useSelector } from 'react-redux';
import icons from 'utils/ui/icons';

const RootMain = styled('div')({
    padding: 10,
    width: '100vw'
});

const StyledPaper = styled(Paper)({
    borderRadius: 0,
    padding: 0,
    width: '100%',
    display: 'flex',
    alignItems: 'center'
});

const InputDiv = styled('div')({
    padding: 0,
    width: 'calc(100% - 48px)'
});

const StyledInputBase = styled(InputBase)({
    fontSize: 12,
    padding: '10px 15px',
    width: '100%'
});

const Component = () => {
    const searchValue = useSelector(state => state.sites.searchValue);
    const changeSearch = actions.useChangeSearch();

    return (
        <RootMain>
            <StyledPaper>
                <InputDiv>
                    <StyledInputBase
                        onChange={event => changeSearch(event.target.value)}
                        placeholder="Search by site name, organization name or current status"
                        value={searchValue}
                    />
                </InputDiv>
                <IconButton onClick={() => router.navigate('/sites')}>
                    <Icon fixedWidth icon={icons.sites} size="xs"/>
                </IconButton>
            </StyledPaper>
        </RootMain>
    );
};

export default Component;
